import React, { useMemo } from 'react';
import Gallery from 'react-galleria';
import { postImageSetting, S3_LARGE_THUMB, S3_URL } from 'constants/index';
import { setModalConfig } from 'store/common';
import { getFileName } from 'utils';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';
import useAuthStore from 'store/auth';
import PostPhotoGalleryMediaItem from './PostPhotoGalleryMediaItem';

const PostPhotoGallery: React.FC<any> = ({ mediaItems, useS3Path = false }) => {
	const { token }: Record<string, any> = useAuthStore((state) => state.userInfo ?? {});
	const { translate } = useTranslate();
	const photos = useMemo(() => {
		const copyMedia = [...mediaItems].slice(0, 4);
		const numMediaItems: number = copyMedia.length;
		const settings = postImageSetting[numMediaItems] || [];
		const limitedSettings = settings.slice(0, 4);

		return copyMedia?.map((item: any, index: number) => {
			const { file } = item;
			const { width, height } = limitedSettings[index] || { width: 0, height: 0 };
			return {
				src: `${useS3Path ? S3_URL : S3_LARGE_THUMB}${file}` || '',
				width,
				height,
				index,
				videoThumbnail: useS3Path ? S3_URL : S3_LARGE_THUMB + getFileName(file),
			};
		});
	}, [mediaItems]);

	const onAssetsClick = (index: number) => {
		if (!token) {
			setModalConfig({
				visible: true,
				type: 'loginModal',
			});
		} else {
			setModalConfig({
				visible: true,
				data: mediaItems,
				id: index,
				type: 'carouselModal',
				props: {
					fullscreen: true,
					centered: true,
					dialogClassName: 'dialog-assets-carousel',
				},
			});
		}
	};

	const getMediaType = (url: any) => {
		const extension = url?.split('.').pop().toLowerCase();
		const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv'];

		if (videoExtensions.includes(extension)) {
			return 'video';
		}
		return 'image';
	};

	const renderImage = ({ photo }: any) => {
		const { src, width, height, index, videoThumbnail } = photo;
		const mediaType = getMediaType(src);
		const showOverlay = index === 3 && mediaItems?.length - photos?.length > 0;
		const overlayText = `+${mediaItems?.length - photos?.length} ${translate('Common.more')}`;
		return (
			<PostPhotoGalleryMediaItem
				key={`${src}-${index}`}
				mediaType={mediaType}
				src={src}
				width={width}
				height={height}
				videoThumbnail={videoThumbnail}
				showOverlay={showOverlay}
				overlayText={overlayText}
				onClick={() => onAssetsClick(index)}
			/>
		);
	};

	let galleryClass = '';
	if (photos.length === 1) {
		galleryClass = 'single-image';
	} else if (photos.length === 2) {
		galleryClass = 'double-image';
	} else if (photos.length === 3) {
		galleryClass = 'triple-image';
	}
	return (
		<div style={{ marginBottom: '10px' }} className={`post-photo-gallery ${galleryClass}`}>
			<Gallery photos={photos} direction={'column'} renderImage={renderImage} />
		</div>
	);
};

export default PostPhotoGallery;
